<template>
	<article class="d-book-the-mayor-custom">
		<PageHero
			:title="header.title"
			:description="header.description"
			v-bind="{ breadcrumb }"
		/>
		<div class="mx-auto relative w-5col >=768:w-6col max-w-full mt-xl">
			<div
				v-if="content"
				class="s-rich-text w-full mb-lg"
				v-html="content"
			></div>
			<BookMayorCardForm
				v-for="meeting in meetings"
				:key="meeting.id"
				:meeting="meeting"
				:form-items="formItems"
				:redirect="thankYouRedirect"
			/>
		</div>
	</article>
</template>

<script>
import PageHero from '~/components/main/PageHero';
import BookMayorCardForm from '~/components/main/BookMayorCardForm';

export default {
	name: 'MainBookTheMayorCustom',
	components: { PageHero, BookMayorCardForm },
	inheritAttrs: false,

	props: {
		title: String,
		header: {
			type: Object,
			required: true,
		},
		breadcrumb: {
			type: Array,
			required: false,
		},
		meetings: {
			type: Array,
			required: false,
		},
		formItems: {
			type: Array,
			required: false,
		},
		content: String,
		thankYouRedirect: Object,
	},
};
</script>
